import { ErrorPage } from './error/ErrorPage';

export function Component(): JSX.Element {
  return (
    <ErrorPage
      title="Sorry, we couldn't find that page"
      message="The page you're searching for doesn't exist anymore, either it has been moved or the link is broken."
      showHomepageLink={true}
    />
  );
}

Component.displayName = 'NoPage';
